 import * as React from "react"

 const arrowIcon = () => (
  <div className="enquire--icon with--icon outline-grey">
    <div className="icon"></div>
  </div>
)

export default arrowIcon
